interface Section { name: string; isStage: boolean; images: string[] }

const NS = "http://www.w3.org/2000/svg";
const PADDING = 24;
const GAP = 16;
const HEADING_HEIGHT = 34;

export const composePlanSvg = (sections: Section[]): string => {
    const scripted = sections.filter(section => section.images.length > 0);
    if (scripted.length === 0) throw new Error("INVALID_BLOCKS");
    const document = window.document.implementation.createDocument(NS, "svg", null);
    const root = document.documentElement;
    let x = PADDING;
    let height = 0;
    for (const section of scripted) {
        let y = PADDING;
        const label = document.createElementNS(NS, "text");
        label.setAttribute("x", String(x));
        label.setAttribute("y", String(y + 20));
        label.setAttribute("font-family", "Arial, sans-serif");
        label.setAttribute("font-size", "20");
        label.setAttribute("font-weight", "bold");
        label.setAttribute("fill", "#242424");
        label.textContent = section.isStage ? "Scena / tło" : `Duszek: ${section.name}`;
        root.appendChild(label);
        let columnWidth = label.textContent.length * 13;
        y += HEADING_HEIGHT;
        for (const source of section.images) {
            const comma = source.indexOf(",");
            if (!source.startsWith("data:image/svg+xml") || comma < 0) throw new Error("INVALID_BLOCKS");
            const image = new DOMParser().parseFromString(decodeURIComponent(source.slice(comma + 1)), "image/svg+xml").documentElement;
            const imageWidth = Number(image.getAttribute("width"));
            const imageHeight = Number(image.getAttribute("height"));
            if (image.localName !== "svg" || !Number.isFinite(imageWidth) || !Number.isFinite(imageHeight) ||
                imageWidth <= 0 || imageHeight <= 0) throw new Error("INVALID_BLOCKS");
            const nested = document.importNode(image, true) as unknown as SVGSVGElement;
            nested.setAttribute("x", String(x));
            nested.setAttribute("y", String(y));
            root.appendChild(nested);
            columnWidth = Math.max(columnWidth, imageWidth);
            y += imageHeight + GAP;
        }
        height = Math.max(height, y - GAP + PADDING);
        x += columnWidth + GAP;
    }
    const width = Math.max(320, x - GAP + PADDING);
    root.setAttribute("width", String(Math.ceil(width)));
    root.setAttribute("height", String(Math.ceil(height)));
    root.setAttribute("viewBox", `0 0 ${Math.ceil(width)} ${Math.ceil(height)}`);
    const background = document.createElementNS(NS, "rect");
    background.setAttribute("width", "100%");
    background.setAttribute("height", "100%");
    background.setAttribute("fill", "white");
    root.insertBefore(background, root.firstChild);
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(document))}`;
};
